/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 24/11/2013
 * Time: 15:53
 * To change this template use File | Settings | File Templates.
 */


angular.module('FlexyBeautyApp.services').factory('CompanyMigrationSettings_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/company-migration-settings/:id', {}, {
        query: {method: 'GET', isArray: false},
        get: {method: 'GET'},
        displayBannerPopUp: {method: 'POST', url: baseUrl + 'rest/company-migration-settings/display-banner-pop-up'}
    });
}
]);

angular.module('FlexyBeautyApp.services').factory('CompanyMigrationSettings', ["CompanyMigrationSettings_Resource",
    function (CompanyMigrationSettings_Resource) {
        var CompanyMigrationSettings = function (resource) {
            this.companyCode = null;
            this.forceMigrationDate = null;
            this.migrationInformationDate = null;
            this.displayBannerPopUp = null
            if (resource !== undefined && resource != null) {
                this.loadObject(resource);
            }
        };

        CompanyMigrationSettings.prototype.loadObject = function (object) {
            this.companyCode = object.companyCode;
            this.forceMigrationDate = object.forceMigrationDate;
            this.displayBannerPopUp = object.displayBannerPopUp;
            this.migrationInformationDate = object.migrationInformationDate;
        };
        return CompanyMigrationSettings;
    }
]);

angular.module('FlexyBeautyApp.services').factory('CompanyMigrationSettingsSrv', ["$log", "CompanyMigrationSettings_Resource", "CompanyMigrationSettingsData", "CompanyMigrationSettings", "ServerSrv",
    function ($log, CompanyMigrationSettings_Resource, CompanyMigrationSettingsData, CompanyMigrationSettings, ServerSrv) {
        var companyMigrationSettingsSrv = {};

        companyMigrationSettingsSrv.query = function (successFunction, errorFunction) {
            CompanyMigrationSettings_Resource.query(
                {}, //params
                function (data) {
                    CompanyMigrationSettingsData.companyMigrationSettings = new CompanyMigrationSettings(data);

                    if (successFunction !== undefined)
                        successFunction();
                },
                function (data) {
                    $log.error(data);
                    if (errorFunction !== undefined)
                        errorFunction(data);
                });
        };

        companyMigrationSettingsSrv.displayBannerPopUp = function (displayBannerPopUp, successFunction, errorFunction) {
            const companyMigrationSettingsResource = new CompanyMigrationSettings_Resource();
            companyMigrationSettingsResource.displayBannerPopUp = displayBannerPopUp;
            companyMigrationSettingsResource.$displayBannerPopUp({}, function () {
                try {
                    if (successFunction != undefined) {
                        successFunction();
                    }
                } finally {
                    ServerSrv.endSavingProcess(true);
                }
            }, function () {
                if (errorFunction != undefined) {
                    errorFunction();
                }
            })
        }

        return companyMigrationSettingsSrv;
    }
]);

angular.module('FlexyBeautyApp.services').factory('CompanyMigrationSettingsData', ["$log", function ($log) {
    var companyMigrationSettingsData = {
        companyMigrationSettings: null,
    };
    companyMigrationSettingsData.getCompanyMigrationSettings = function () {
        return this.companyMigrationSettings;
    };

    return companyMigrationSettingsData;
}
]);



// WEBPACK FOOTER //
// ./js/services/models/CompanyMigrationSettings.js